import FuseDialog from '@fuse/core/FuseDialog';
import FuseMessage from '@fuse/core/FuseMessage';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import FuseSuspense from '@fuse/core/FuseSuspense';
import { makeStyles } from '@material-ui/core/styles';
import AppContext from 'app/AppContext';
import SettingsPanel from 'app/fuse-layouts/shared-components/SettingsPanel';
import clsx from 'clsx';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import LeftSideLayout1 from './components/LeftSideLayout1';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import RightSideLayout1 from './components/RightSideLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';
import SocketNotification from 'context/socketNotification';
import {socket} from 'context/socket';
import {trackUserIdleState, userIdleStateEmiter, checkOtherUserStatus, sendSignalForUserLastActivity} from 'context/track-idel-time';
import * as Actions from 'app/store/actions';
// import Calling from 'app/main/apps/calling';
// import CallingListener from 'app/main/apps/calling/calling-listener';
// import CallingPopup from 'app/main/apps/calling/popup';
import { useLocation } from 'react-router-dom';
import $ from 'jquery'
//import AudioCall from 'app/main/apps/chat/AudioCall'
import * as HELPER from 'context/helper'

const useStyles = makeStyles(theme => ({
	root: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
		height: '100%',
		overflow: 'hidden',
		backgroundColor: theme.palette.background.default,
		color: theme.palette.text.primary,
		'&.boxed': {
			maxWidth: 1280,
			margin: '0 auto',
			boxShadow: theme.shadows[3]
		},
		'&.scroll-body': {
			'& $wrapper': {
				height: 'auto',
				flex: '0 0 auto',
				overflow: 'auto'
			},
			'& $contentWrapper': {},
			'& $content': {}
		},
		'&.scroll-content': {
			'& $wrapper': {},
			'& $contentWrapper': {},
			'& $content': {}
		},
		'& .navigation': {
			'& .list-subheader-text, & .list-item-text, & .item-badge, & .arrow-icon': {
				transition: theme.transitions.create('opacity', {
					duration: theme.transitions.duration.shortest,
					easing: theme.transitions.easing.easeInOut
				})
			}
		}
	},
	wrapper: {
		display: 'flex',
		position: 'relative',
		width: '100%',
		height: '100%',
		flex: '1 1 auto'
	},
	contentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		zIndex: 3,
		overflow: 'hidden',
		flex: '1 1 auto'
	},
	content: {
		position: 'relative',
		display: 'flex',
		overflow: 'auto',
		flex: '1 1 auto',
		flexDirection: 'column',
		width: '100%',
		'-webkit-overflow-scrolling': 'touch',
		zIndex: 2
	}
}));

function Layout1(props) {
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const appContext = useContext(AppContext);
	const classes = useStyles(props);
	const { routes } = appContext;
	const connectedUser = useSelector(({ user }) => user ? user?.user : JSON.parse(localStorage.getItem('current_user')));
	const dispatch = useDispatch();
	const location = useLocation()
	const state = useSelector(({ chatPanel }) => chatPanel);
	//const calling = useSelector(({ calling }) => calling);
	const waitingCall = localStorage.getItem("callingInformation");
	const waitingCallInfo = JSON.parse(waitingCall);

	useEffect(() => {
		// runs on location, i.e. route, change
		setTimeout(function() {
			let navSelected = $(".navigation").find('a[aria-current]:first').find('div>span')
			let title = $(navSelected).text()
			title !== "" ? document.title = title + " | SCAI" : document.title = "Login | SCAI"
		}, 500);
	}, [location])

	window.onbeforeunload = function(){	
		//var IS_IDLE_STATE = true;	
		console.log("website is gonna refresh")
		userIdleStateEmiter();	
		/*if(var IS_CALL_INITIATED === true){	TO DO when we will manage call in chat, manage with state
		  return "If you refresh the page, call will be disconnected.";	
		}	*/
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const sendResponseTOSocketOnPageReady = async () => {
		
		let _loggedUserId = connectedUser.id
		
		if(_loggedUserId && _loggedUserId !== undefined) {
			let _socketData = {}
				_socketData.userId = _loggedUserId;
				_socketData.deviceId = await HELPER.getDeviceId();
				_socketData.authToken = connectedUser.authToken;
			socket.emit("socket_connecion_success", _socketData)
		}
	}

	useEffect(() => {
		sendResponseTOSocketOnPageReady()
	}, [sendResponseTOSocketOnPageReady]);

	useEffect(() => {
		const init = async () => {
			setTimeout(async ()=>{
				//await refreshChatList();
				await trackUserIdleState(connectedUser);
				await checkOtherUserStatus(connectedUser);
				await sendSignalForUserLastActivity(connectedUser);
				//console.log("----------- sendSignalForUserLastActivity -----------")
			  },2000);
		}
		socket.on("check_users_activity_success", async (data) => {

			//console.log("check_users_activity_success",data)
	   	})
		   connectedUser.id && init()
		   return async () => {
				//console.log("test if user is there sendSignalForUserLastActivity")
				await trackUserIdleState(connectedUser);
				await checkOtherUserStatus(connectedUser);
				await sendSignalForUserLastActivity(connectedUser);
		   }
	}, [connectedUser])

	useEffect(() => {
		socket.emit("get_status_users", connectedUser)
		socket.on("get_status_users_success", async (users) => {
			//console.log("get_status_users_success", users)
			dispatch(Actions.getStatusUsers(users.user_data))
		})
		socket.on("user_logged_out", async (_data) => {
			socket.emit("get_status_users", connectedUser)
		})
		socket.on("user_logged_in", async (_data) => {
			socket.emit("get_status_users", connectedUser)
		})
		socket.on("user_status_changed", async (res) => {
			//console.log("user_status_changed")
			socket.emit("get_status_users", connectedUser)
	   	})

		   
		let _formValues = {
			userId: connectedUser.id,
			reqStatus: localStorage.getItem('initialStatus'),
			authToken: connectedUser.authToken
		}
		//console.log("website refreshed, status too", _formValues)
		socket.emit("change_user_status", _formValues)

		/* If user who refresh his screen has a pending call, he should be able to join */
		waitingCallInfo && waitingCallInfo.callLogId && 
			//console.log("un appel en cours", waitingCall)
			dispatch(Actions.displayUiWhenCalling(false,JSON.parse(waitingCall)))
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	switch (config.scroll) {
		case 'body': {
			return (
				<div id="fuse-layout" className={clsx(classes.root, config.mode, `scroll-${config.scroll}`)}>
					{/* {(calling.calling.initAudioCall === true || calling.calling.isCallAccepted === true) === true &&
						<AudioCall />
					} */}
					{/* <SocketNotification />  */}
					{/* <Calling />
					<CallingListener />
					{calling.calling.isCallAccepted !== true && <CallingPopup />} */}
					{config.leftSidePanel.display && <LeftSideLayout1 />}

					<div className="flex flex-1 flex-col overflow-hidden relative">
						{config.toolbar.display &&
							config.toolbar.style === 'fixed' &&
							config.toolbar.position === 'above' && <ToolbarLayout1 />}

						<FuseScrollbars className="overflow-auto" scrollToTopOnRouteChange>
							{config.toolbar.display &&
								config.toolbar.style !== 'fixed' &&
								config.toolbar.position === 'above' && <ToolbarLayout1 />}

							<div className={classes.wrapper}>
								{config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

								<div className={classes.contentWrapper}>
									{config.toolbar.display && config.toolbar.position === 'below' && (
										<ToolbarLayout1 />
									)}

									<div className={classes.content}>
										<FuseDialog />

										<FuseSuspense>{renderRoutes(routes)}</FuseSuspense>

										{props.children}
									</div>

									

									<SettingsPanel />
								</div>

								{config.navbar.display && config.navbar.position === 'right' && (
									<NavbarWrapperLayout1 />
								)}
							</div>

							
						</FuseScrollbars>

						
					</div>

					{config.rightSidePanel.display && <RightSideLayout1 />}

					<FuseMessage />
				</div>
			);
		}
		case 'content':
		default: {
			return (
				<div id="fuse-layout" className={clsx(classes.root, config.mode, `scroll-${config.scroll}`)}>
					{/* {(calling.calling.initAudioCall === true || calling.calling.isCallAccepted === true) &&
						<AudioCall />
					} */}
					{/* <SocketNotification /> */}
					{/* <Calling />
					<CallingListener />
					{calling.calling.isCallAccepted !== true && <CallingPopup />} */}
					{config.leftSidePanel.display && <LeftSideLayout1 />}

					<div className="flex flex-1 flex-col overflow-hidden relative">
						{config.toolbar.display && config.toolbar.position === 'above' && <ToolbarLayout1 />}

						<div className={classes.wrapper}>
							{config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

							<div className={classes.contentWrapper}>
								{config.toolbar.display &&
									config.toolbar.position === 'below' &&
									config.toolbar.style === 'fixed' && <ToolbarLayout1 />}

								<FuseScrollbars className={classes.content} scrollToTopOnRouteChange>
									{config.toolbar.display &&
										config.toolbar.position === 'below' &&
										config.toolbar.style !== 'fixed' && <ToolbarLayout1 />}

									<FuseDialog />

									<FuseSuspense>{renderRoutes(routes)}</FuseSuspense>

									{props.children}

									
								</FuseScrollbars>

								

								<SettingsPanel />
							</div>

							{config.navbar.display && config.navbar.position === 'right' && <NavbarWrapperLayout1 />}
						</div>

					</div>

					{/* Connect Side Panel Removed*/}
					{/* {config.rightSidePanel.display && <RightSideLayout1 />} */}

					<FuseMessage />
				</div>
			);
		}
	}
}

export default React.memo(Layout1);